import React from 'react';
import styled from 'styled-components';

import CardWrapper from './CardWrapper';
import NewTagButton from './NewTagButton';
import TruncatedTag from './TruncatedTag';

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 10px;
`;

export interface TagsManagerProps {
  activeTags?: string[];
  addTag: (tag: string) => void;
  removeTag: (tag: string) => void;
  title?: string;
}

function TagsManager({
  activeTags,
  addTag,
  removeTag,
  title,
}: TagsManagerProps) {
  return (
    <CardWrapper title={title || 'Tags'}>
      <Container>
        {(activeTags || []).map((tag) => (
          <TruncatedTag
            key={`tagManager.tag.${tag}`}
            label={tag}
            onRemove={() => removeTag(tag)}
          />
        ))}

        <NewTagButton onSubmit={addTag} />
      </Container>
    </CardWrapper>
  );
}

export default TagsManager;
